import { Typography } from 'antd';

const { Text } = Typography;

const CaregiverRequestFailedModal = () => (
  <div className="flex flex-col gap-y-2">
    <div className="flex flex-col">
      <Text className="text-sm">An error occurred while processing your request.</Text>
      <Text className="text-sm">Please try again.</Text>
    </div>
    <Text className="text-sm">If error persists, please try again later.</Text>
    <Text className="text-sm">(Code: LB0004)</Text>
  </div>
);

export default CaregiverRequestFailedModal;
